import { Card, CardContent, Box, Typography } from "@mui/material";

const IMAGE_MAX_HEIGHT = 240;
const OVERLAP_PADDING = IMAGE_MAX_HEIGHT / 2;

const NotificationCard = ({
  imageSrc,
  altText = "notification graphic",
  text,
  sx = {},
}) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "80vh",
      px: 2,
    }}
  >
    <Box
      sx={{
        position: "relative",
        width: { xs: "100%", sm: "80%", md: "60%" },
        maxWidth: 600,
      }}
    >
      <Card
        sx={{
          textAlign: "center",
          p: 2,
          pt: `${OVERLAP_PADDING}px`,
          boxShadow: 3,
          borderRadius: 2,
          ...sx,
        }}
      >
        <CardContent sx={{ p: 0 }}>
          <Typography
            sx={{
              fontSize: {
                xs: "1rem",
                sm: "1.25rem",
                md: "1.5rem",
              },
              fontWeight: 500,
            }}
            gutterBottom
          >
            {text}
          </Typography>
        </CardContent>
      </Card>
      <Box
        component="img"
        src={imageSrc}
        alt={altText}
        sx={{
          position: "absolute",
          top: 0,
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxHeight: IMAGE_MAX_HEIGHT,
          maxWidth: "100%",
        }}
      />
    </Box>
  </Box>
);

export default NotificationCard;
